import React, { useEffect } from "react";
import style from "./DropCard.module.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Drop from "./Drop";
import { PropTypes } from "prop-types";
import { useDrop } from "react-dnd";
import { useState } from "react";
import CustomSelect from "../Select/CustomSelect";
import CustomSwitch from "../Switch/CustomSwitch";
import { getLocationList } from "../../Services/caseManagement.service";
import useToaster from "../../customHook/useToaster";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { stateShortFormObj } from "../../Utils/helper";

const DropCard = ({
  data,
  label,
  location,
  droppedItemDetails = () => {},
  onTapped = () => {},
  isReassign,
  reassignType,
  isAssigned,
  investigator,
  investigatorDetails,
  isSelectAll = false,
  onDeleteItem = () => {},
  isLocationSelectOpen,
  locationDropClickHandler = () => {},
  mapAssignedData = () => {},
  setDatatoSend = () => {},
}) => {
  const [mapData, setMapData] = useState([]);
  const [dropdownData, setDropdownData] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [specialisedSwitch, setSpecialisedSwitch] = useState(0);
  const [{ isOver, isOverCurrent }, drop] = useDrop(
    () => ({
      accept: "string",
      drop(_item, monitor) {
        const didDrop = monitor.didDrop();
        const dataList = data.filter(
          (item) => _item?.block_master_id === item?.block_master_id
        );
        const isAlreadyExist = mapData.filter(
          (item) => item?.block_master_id === _item?.block_master_id
        );
        // if (dataList[0]?.isAssigned) {
        //   return null;
        // } else {
        if (isAlreadyExist?.length) {
          return;
        }
        setMapData((board) => {
          let arr = [...board, dataList[0]];
          return [...new Set(arr)];
        });
        droppedItemDetails(
          {
            ..._item,
          },
          {
            state: selectedState,
            city: selectedCity,
            isSpecialised: specialisedSwitch,
          }
        );
        // }
      },
      collect: (monitor) => ({
        isOver: monitor.isOver(),
        isOverCurrent: monitor.isOver({ shallow: true }),
      }),
    }),
    [
      droppedItemDetails,
      selectedState,
      selectedCity,
      specialisedSwitch,
      mapData,
    ]
  );
  const { showToast } = useToaster();

  const onTappedLocal = (investigator) => {
    setMapData(data);
    onTapped(null, investigator, {
      state: selectedState,
      city: selectedCity,
      isSpecialised: specialisedSwitch,
    });
  };

  const locationDropdownStyle = {
    backgroundColor: "#F1F5F9",
    mb: "0.5rem",
  };

  const stateChangeHandler = (e) => {
    setSelectedState(e.target.outerText || "");
    setSelectedCity("");
  };
  const selectCityHandler = (e) => {
    setSelectedCity(e.target.outerText || "");
    if (e?.target?.outerText?.trim()?.length) {
      locationDropClickHandler();
    }
  };
  const switchHandler = (e) => {
    setSpecialisedSwitch(e.target.checked ? 1 : 0);
  };

  useEffect(() => {
    try {
      getLocationList()
        ?.then((response) => {
          if (response?.success) {
            setDropdownData([...response?.data]);
          }
        })
        ?.catch((err) => {
          showToast(err?.response?.data?.message, "error", true);
        });
    } catch (err) {
      showToast("Error while fetching location list", "error", true);
    }
  }, []);

  useEffect(() => {
    let selectedDetails = {
      state: selectedState,
      city: selectedCity,
      isSpecialised: specialisedSwitch,
    };
    mapAssignedData(null, investigator, false, selectedDetails);
  }, [selectedState, selectedCity, specialisedSwitch]);

  useEffect(() => {
    if (isReassign && investigatorDetails && investigator <= 1) {
      let { blocksAssigned = [], state = "", city = "" } = investigatorDetails;
      setSelectedState(state || "");
      setSelectedCity(city || "");
      setTimeout(() => {
        setDatatoSend([
          {
            blocksAssigned,
            state,
            city,
            isSpecialised: 0,
          },
        ]);
      }, 50);
    }
  }, [isReassign, investigatorDetails, investigator]);

  useEffect(() => {
    if (isReassign && investigator <= 1 && !mapData?.length) {
      let updatedMapData = data?.filter((obj) => obj?.isAssigned);
      setMapData([...updatedMapData]);
    }
  }, [data, isReassign, investigator, mapData]);

  return (
    <div
      ref={drop}
      className={style["drop_element-conatiner"]}
      onClick={() => isSelectAll && onTappedLocal(investigator)}
    >
      <div className={style["label-div-main"]}>
        <div className={style["label-div"]}>
          <h3 className={style["label-h3"]}>{label}</h3>
        </div>
      </div>
      <div className={style["small-navBar"]}>
        <div className={style["specialized-css-div"]}>
          <p
            className={style["specialized-css"]}
            style={{ width: "80px", fontSize: "1.2rem", margin: "5px 16px" }}
          >
            Specialized Vendor{" "}
          </p>
          <CustomSwitch
            sx={{
              marginTop: "12px",
            }}
            checked={specialisedSwitch ? true : false}
            onChange={switchHandler}
          />
        </div>
        <div
          className={style["small-navBar-rightSide-element"]}
          onClick={locationDropClickHandler}
        >
          {selectedState && selectedCity ? (
            <h5 className={style["location-css"]}>{`${selectedCity
              .split("")
              .map((item, index) =>
                index !== 0 ? item.toLowerCase() : item.toUpperCase()
              )
              .join("")}, ${stateShortFormObj[selectedState]}`}</h5>
          ) : (
            <p>{location}</p>
          )}
          {isLocationSelectOpen ? (
            <KeyboardArrowUpIcon sx={{ color: "#505050", fontSize: "2rem" }} />
          ) : (
            <KeyboardArrowDownIcon
              sx={{ color: "#505050", fontSize: "2rem" }}
            />
          )}
        </div>
      </div>
      {isLocationSelectOpen && (
        <div className={style["location-dropdown-main-container"]}>
          <CustomSelect
            onChange={stateChangeHandler}
            searchable
            id="state"
            name="state"
            options={[...dropdownData?.map((obj) => obj?.state)]}
            value={selectedState}
            sx={locationDropdownStyle}
            placeholder="Select State"
            disabled={isReassign && reassignType === "same"}
          />
          <CustomSelect
            disabled={
              (isReassign && reassignType === "same") ||
              selectedState.length === 0
                ? true
                : false
            }
            onChange={selectCityHandler}
            searchable
            id="city"
            name="city"
            options={[
              ...(dropdownData?.find(
                (obj) =>
                  obj?.state?.toLowerCase() == selectedState?.toLowerCase()
              )?.city || []),
            ]}
            value={selectedCity}
            sx={locationDropdownStyle}
            placeholder="Select City / District"
          />
        </div>
      )}

      <div
        className={
          style[
            mapData?.length <= 0
              ? "map_data-conatiner"
              : "map-data-list-conatiner"
          ]
        }
      >
        {mapData?.length <= 0 ? (
          <p className={style["drag-blocks"]}>
            {isSelectAll ? "Click here" : "Drag Blocks"}
          </p>
        ) : (
          mapData?.map((item, id) => {
            return (
              <Drop
                label={item?.block_name}
                key={id}
                id={item?.block_master_id}
                isDraggable={false}
                isPrevSelected={item?.isPrevSelected && investigator <= 1}
                // onClickHandler={deleteItem(item?.id)
                // }
                onDeleteItem={(e, id) => {
                  let updatedItem = mapData.filter(
                    (item) => item?.block_master_id !== id
                  );
                  setMapData(updatedItem);
                  onDeleteItem(e, id, investigator);
                }}
              />
            );
          })
        )}
      </div>
    </div>
  );
};

DropCard.propTypes = {
  label: PropTypes.string,
  location: PropTypes.string,
  drop: PropTypes.func,
  mapData: PropTypes.array,
  isAssigned: PropTypes.array,
  mapAssignedData: PropTypes.func,
};

export default DropCard;
